




















































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { BNavItemDropdown, BDropdownItem, BPopover } from "bootstrap-vue";

@Component({
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BPopover,
  },
  computed: mapState("auth", ["user"]),
})
export default class Header extends Vue {
  logout() {
    this.$store.dispatch("auth/logout");
    this.$router.push({ name: "login" });
  }

  getReportLinks(category, module) {
    if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ADMIN_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks.filter(
        (r) => r.category === category && r.module === module
      );
    } else if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks.filter(
        (r) =>
          r.category === category && r.module === module && r.admin === false
      );
    }
    return [];
  }

  getReportLinkCategories(module) {
    if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ADMIN_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks
        .filter((r) => r.module === module)
        .map((r) => r.category)
        .filter((v, i, a) => a.indexOf(v) === i);
    } else if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks
        .filter((r) => r.module === module && r.admin === false)
        .map((r) => r.category)
        .filter((v, i, a) => a.indexOf(v) === i);
    }
    return [];
  }

  removeSpaces(values) {
    return values.replace(/ /g, "");
  }

  setReportLink(link) {
    this.$store.state.gaps.reportLink = link;
    //this.$root.$emit("bv::hide::popover", "cases-menu-target");
    this.$root.$emit("bv::hide::popover");
  }
}
